import { get } from "lodash";
import { DefaultRootState } from "react-redux";
import { parseJSONCapiMessage } from "@fdr/utils/parseJSONCapiMessage";
import { HandicappingSectionItems } from "../types";

export const getPromoCardsModalOpen = (store: unknown) =>
  get(store, "modal.isPromoCardsModalOpen", false);

export const getOptedInMessage = (store: DefaultRootState) =>
  parseJSONCapiMessage(store, "capi.messages.optedInMessage", "");
export const getHandicappingInfoPromos = (
  store: DefaultRootState
): HandicappingSectionItems =>
  parseJSONCapiMessage(store, "capi.messages.handicappingInfoPromos", {});
